module.exports = __webpack_public_path__ + "static/media/Social Image.e90ec1e0.jpg";